<div class="w-full h-full flex items-center justify-center flex-col p-16 gap-16 text-center">
  <mat-icon class="empty-state-icon text-bat-value_a50" svgIcon="chat" />

  <div class="flex flex-col gap-4">
    <div class="text-bat-value text-14 font-medium">{{ title() }}</div>
    <div class="text-bat-value_a50 text-12">{{ description() }}</div>
  </div>

  @if (!menuVisible() && hasConversations()) {
    <button
      type="button"
      class="flex items-center justify-center gap-8 p-8 border border-solid border-bat-accent text-bat-accent text-14 font-medium rounded"
      (click)="openMenu.emit()"
    >
      <mat-icon svgIcon="icon_chevron_left_16" />
      View conversations
    </button>
  }

  @if (showAddButton()) {
    <button
      type="button"
      class="flex items-center justify-center gap-8 p-8 border border-solid border-bat-accent text-bat-accent text-14 font-medium rounded"
      [disabled]="disabled()"
      (click)="createNewConversation.emit()"
    >
      <mat-icon svgIcon="icon_add_16" />
      New Conversation
    </button>
  }
</div>
